/* main-collection.js
   Externalized from sections/main-collection.liquid (blocks 1-4).
   Loaded deferred + cached + minified by Shopify. The Liquid data engine
   (block 0: api_data / filter_values) stays inline in the section because it
   is a server-rendered per-product dump. Config values are read from the
   inline #mc-collection-config JSON blob. The heavy per-product catalog is
   fetched from templates/collection.catalog.liquid (mcRt.catalogUrl) inside
   plBuildCatalog(), which variantsData().init() awaits. Factory functions are defined at
   top level (no IIFE) so Alpine x-data can resolve them; they are inert until
   Alpine instantiates the mode-gated markup, so defining them in both modes
   is safe. */
(function () {
  var _el = document.getElementById('mc-collection-config');
  window.mcCfg = _el ? JSON.parse(_el.textContent) : {};
})();
var mcCfg = window.mcCfg;

/* --- Runtime config (block 0 externalization) ---
   Everything below used to execute inline in main-collection.liquid during HTML
   parse. It now initializes here from the tiny #mc-runtime-config blob; the heavy
   per-product catalog is fetched asynchronously in plBuildCatalog() (awaited
   by variantsData().init()), keeping it entirely off the parser's critical
   path and out of the page HTML. In non-variant mode the blobs are absent and everything
   degrades to inert defaults. */
(function () {
  var _el = document.getElementById('mc-runtime-config');
  window.mcRt = _el ? JSON.parse(_el.textContent) : {};
})();
var mcRt = window.mcRt;

var pushUnique = function (arr, value) {
  if (!arr.includes(value)) arr.push(value);
};

var filter_keyword = (mcRt.filterKeyword || []).map(function (k) {
  return String(k).trim().replace(/['"]/g, '');
});
var display_only_sale_variants = mcRt.displayOnlySaleVariants || false;
var length_variants_enabled = (mcCfg.lengthVariants === true || mcCfg.lengthVariants === 'true');

/**
 * Helper function to check if a variant matches filter keywords
 * Uses EXACT matching for length values (numeric keywords like "10", "12", "14")
 * Uses SUBSTRING matching for color/text values (like "Auburn", "Blonde")
 */
function variantMatchesFilterKeyword(variant, lengthOptionPosition, colorOptionPosition, keywords) {
  if (!keywords || !keywords.length) return true;

  const variantLength = variant[lengthOptionPosition]
    ? String(variant[lengthOptionPosition]).replace(/['"]/g, '').split('/')[0].trim()
    : '';

  const variantColor = variant[colorOptionPosition]
    ? String(variant[colorOptionPosition]).trim()
    : '';

  const variantTitle = variant.title || '';

  return keywords.some(keyword => {
    const kw = keyword.trim();
    const isLengthKeyword = /^\d+(\.\d+)?$/.test(kw);

    if (isLengthKeyword) {
      return variantLength === kw || variantLength === kw + '"';
    } else {
      return variantTitle.includes(kw) || variantColor.includes(kw);
    }
  });
}

var filter_values = {
  availability: ['In stock', 'Out of stock'],
  /* Discount tiers present in this grid, as strings ("20", "30", ...). Built
     from custom.promo_tier on each variant. The facet only renders when this
     holds MORE THAN ONE value - a grid where everything is the same percentage
     has nothing to filter, so the pills would be noise. */
  discount: [],
  length: [],
  color: [],
  size: [],
  texture: [],
  skill_level: [],
  method: [],
  hair_type: []
};

const safelyPushUnique = (key, value) => {
  if (value) pushUnique(filter_values[key], value);
};

/* Shade-group classification. Single source of truth shared by the grid
   filter (hasItem) and the shade-group filter buttons (plGroupPresent),
   so a group appears in the sidebar if and only if the grid can filter to it.
   Order matters: first match wins. Balayage is checked BEFORE Brown/Blonde/
   Blends because most balayage names contain those substrings (e.g. "Ashy
   Brown Balayage", "Pearl Bronde Balayage") and would otherwise be
   misclassified into the wrong group. */
var plColorGroups = {
  "Ombre": ["Ombre"],
  "Balayage": ["Balayage"],
  "Rooted": ["Rooted"],
  "Highlights": ["Highlights", "Lowlights", "Highlighted", "Piano"],
  "Red": ["Auburn", "Burgundy", "Crimson", "Ginger"],
  "Blonde": ["Blonde", "Bronde"],
  "Brown": ["Brown", "Brunette", "Chestnut", "Mocha", "Chocolate", "Caramel", "Toffee"],
  "Gray": ["Gray", "Grey", "Silver"],
  "Black": ["Black", "Jet"]
};
function plGetColorGroup(color) {
  if (!color) return color;
  var lower = color.toLowerCase();
  for (var groupName in plColorGroups) {
    if (plColorGroups[groupName].some(function (keyword) { return lower.includes(keyword.toLowerCase()); })) {
      return groupName;
    }
  }
  return color;
}

/* Global helper for shade-group button visibility. Takes the colors array
   explicitly so it can be called from an Alpine x-show expression with the
   bare (Alpine-scoped, reactive) filter_values.color - no reliance on `this`,
   which is not bound to the component when a method is called from x-show. */
function plGroupPresent(colors, groupLabel) {
  if (!colors || !groupLabel) return false;
  var target = String(groupLabel).toLowerCase();
  return colors.some(function (c) {
    var g = plGetColorGroup(c);
    return g && g.toLowerCase() === target;
  });
}

var section_blocks = mcRt.sectionBlocks || [];

var promoConfig = (function () {
  /* Positions come from each promo block's "Position" setting in the
     theme editor. Falls back to the classic 5/13/21/29 pattern when
     the template sets none. */
  var positions = (mcRt.promoPositions || []).filter(function (p) {
    return typeof p === 'number' && p > 0;
  });
  return {
    basePositions: positions.length ? positions : [5, 13, 21, 29],
    repeatDistance: 32,
    showOnce: true /* each tile renders once per page; set to false to
                      restore the old repeat-every-32 behavior */
  };
})();

/* Card state for the variant grid. Holds the selected length so price, stock and the
   card/Quick-Shop links update in place when a customer taps a length chip, instead of
   doing a blind navigation. Per-length display price is derived from the raw variant
   price + the product's tag discount, exactly mirroring how the representative variant's
   price is computed at build time, so the two never disagree. */
function variantCardState(data, settings) {
  var repLength = (data.variant && data.variant.option2 != null) ? String(data.variant.option2).trim() : '';
  return {
    product_url: '/products/' + data.product.handle + '?variant=' + data.variant.id,
    product: data.product,
    variant: data.variant,
    collection_title: settings ? settings.collection_title : '',
    // Stock is delivered as a bucket ('out' | 'low' | 'in') rather than a raw
    // inventory count: the count was never used for anything finer, and
    // publishing exact stock levels in page source is a data leak.
    variant_stock: (function () {
      var q = data.variant.inventory_quantity;
      var bucket = data.variant.stock || (typeof q === 'number' ? (q < 1 ? 'out' : (q < 5 ? 'low' : 'in')) : 'in');
      return {
        stock_text: bucket === 'out' ? 'Out of Stock' : (bucket === 'low' ? 'Low Stock' : ''),
        class: 'pl-badge pl-badge--sold-out' + (bucket === 'out' ? ' out-of-stock' : (bucket === 'low' ? ' low-stock' : ' in-stock'))
      };
    })(),

    // Reactive selection state (defaults to the card's representative variant).
    // Resolved through the canonical resolver so the initial paint matches what
    // selectLength() computes on interaction.
    sel_length: repLength,
    sel_variant_id: data.variant.id,
    sel_price: (data._pr = (window.plPromo ? window.plPromo.resolve(data.product, data.variant) : { displayPrice: data.variant.price, comparePrice: (data.variant.compare_at_price || 0), badgeType: 'none', badgeLabel: '', badgePct: 0, lcActive: false }), data._pr.displayPrice),
    sel_compare_price: (data._pr.comparePrice > data._pr.displayPrice ? data._pr.comparePrice : null),
    sel_on_sale: data._pr.comparePrice > data._pr.displayPrice,
    sel_promo: data._pr,

    /* --- Card badge + proof line (Oct 2026) ---
       One badge per card: out of stock, New shade, Best Seller, Retired, first
       __label tag. The selected length drives stock state, so the
       badge and the "Only a few left" line follow selectLength(). Shade rank
       comes from custom.bestseller_rank (catalog field bestseller_rank, 1-3),
       which the weekly rank job writes on every length of a ranked shade; the
       card reads the lowest rank across the shade's lengths in case a length
       was added after the last run. */
    shade_rank: (function () {
      var best = (data.variant && data.variant.bestseller_rank) || 0;
      var opt1 = (data.variant && data.variant.option1 != null) ? String(data.variant.option1) : null;
      var vs = (data.product && data.product.variants) || [];
      for (var i = 0; i < vs.length; i++) {
        var r = vs[i].bestseller_rank;
        if (r && opt1 !== null && String(vs[i].option1) === opt1 && (!best || r < best)) best = r;
      }
      return best;
    })(),
    selVariant: function () {
      var id = this.sel_variant_id;
      var vs = (this.product && this.product.variants) || [];
      for (var i = 0; i < vs.length; i++) { if (vs[i].id === id) return vs[i]; }
      return this.variant;
    },
    cardBadge: function () {
      var v = this.selVariant() || {};
      if (this.product.available === false || v.available === false) {
        return { type: 'oos', text: 'Sold out' };
      }
      // custom.last_chance is the campaign pricing switch (it gates promo_tier and
      // the sale price in pl-promo.js), not an end-of-stock signal, so it never
      // drives a badge. The campaign pill under the price already covers it.
      var label = v.variant_label || data.variant_label || '';
      if (label === 'New') return { type: 'new', text: 'New shade' };
      if (this.shade_rank || label === 'Best Seller') return { type: 'best', text: 'Best Seller' };
      if (label === 'Retired') return { type: 'retired', text: 'Retired' };
      var tags = this.product.tags || [];
      for (var i = 0; i < tags.length; i++) {
        var tag = String(tags[i]);
        if (tag.indexOf('__label') === -1) continue;
        var text = tag.split(':')[1];
        if (!text) continue;
        // Same class string the old per-tag badge produced (handleize of the full tag).
        var mod = tag.toLowerCase().replace(/[^a-z0-9\s-]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');
        return { type: 'tag', text: text.trim(), cls: 'pl-badge--custom' + (tag.indexOf('__label2') !== -1 ? ' 2' : '') + ' ' + mod };
      }
      return null;
    },
    proofRank: function () {
      var b = this.cardBadge();
      return (b && b.type === 'oos') ? 0 : (this.shade_rank || 0);
    },
    proofStock: function () {
      var v = this.selVariant() || {};
      if (v.available === false) return false;
      if (v.stock) return v.stock === 'low';
      return typeof v.inventory_quantity === 'number' && v.inventory_quantity > 0 && v.inventory_quantity < 5;
    },

    selectLength: function (label, id, available) {
      if (available === false) return;
      var variants = (this.product && this.product.variants) || [];
      var opt1 = (this.variant && this.variant.option1 != null) ? String(this.variant.option1) : '';
      var target = null;
      if (id != null) target = variants.find(function (v) { return v.id === id; });
      if (!target) {
        target = variants.find(function (v) {
          return String(v.option1 || '') === opt1 && String(v.option2 || '').trim() === label;
        });
      }
      if (!target || target.available === false) return;

      // Canonical resolution (assets/pl-promo.js): one rule set for the whole theme.
      // sel_price / sel_compare_price are the resolved DISPLAY values - Pro pricing,
      // tag campaigns, and both last-chance modes are already applied. The Alpine
      // templates render them directly and must not re-discount.
      // resolve() already returns full price for code-gated campaigns (badgeType
      // 'code'), so no special-casing is needed here.
      var pr = window.plPromo ? window.plPromo.resolve(this.product, target)
        : { displayPrice: target.price, comparePrice: (target.compare_at_price || 0), badgeType: 'none', badgeLabel: '', badgePct: 0, lcActive: false };
      var price = pr.displayPrice;
      var compare = pr.comparePrice > pr.displayPrice ? pr.comparePrice : null;

      this.sel_length = label;
      this.sel_variant_id = target.id;
      this.sel_price = price;
      this.sel_compare_price = compare;
      this.sel_on_sale = compare != null;
      this.sel_promo = pr;
      this.product_url = '/products/' + (this.product.handle || '') + '?variant=' + target.id;

      // Surface length-selection intent for GA4 / GTM and any custom listeners.
      try {
        window.dataLayer = window.dataLayer || [];
        // GA4 ecommerce shape: clear the previous ecommerce object, then push
        // select_item with an items array so GTM/GA4 ecommerce reporting works
        // natively (the old flat push needed GTM-side reshaping).
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          event: 'select_item',
          ecommerce: {
            item_list_name: (this.collection_title || ''),
            items: [{
              item_id: String(target.id),
              item_name: this.product.title,
              item_variant: label,
              price: (typeof price === 'number' ? price / 100 : undefined)
            }]
          }
        });
        window.dispatchEvent(new CustomEvent('pl:length-select', {
          detail: { product_id: this.product.id, variant_id: target.id, length: label, price: price }
        }));
      } catch (e) {}
    }
  };
}

var api_data = {
  variants: [],
  selected_color_values: mcRt.selectedColorValues || [],
  section_blocks: section_blocks,
  settings: mcRt.apiSettings || {}
};

/* --- plBuildCatalog() : lazy catalog build ---
   Parses the inert #mc-catalog-data blob once and reproduces the original inline
   build exactly: filter_values accumulation order, keyword filtering (normal mode
   only), last_chance gating (sale mode only), tag-discount price adjustment, and
   the historical _variant_index convention (1-based in sale mode via forloop.index,
   0-based in normal mode via forloop.index0). Indices count positions in the full
   variants array, including variants that are skipped - matching the original,
   where the loop counter advanced regardless of the inner gate. */
/* Resolve the catalog URL. Prefer the exact string the section wrote into
   #mc-runtime-config (it is also what the <link rel="preload"> used, so the two
   requests coalesce). Fall back to building it from the path + sort_by. */
function plCatalogUrl() {
  if (mcRt.catalogUrl) return mcRt.catalogUrl;
  var params = new URLSearchParams(window.location.search);
  var url = window.location.pathname + '?view=catalog';
  var sort = params.get('sort_by');
  if (sort) url += '&sort_by=' + encodeURIComponent(sort);
  return url;
}

/* Session cache for the catalog text. Scope: one tab, 15 minute TTL, keyed by
   the exact catalog URL (so sort_by variants cache separately). Purpose: a
   shopper hopping between collections or coming Back to one hydrates
   synchronously - no fetch, and the skeleton never mounts, because a skeleton
   over locally-held data reads as fake loading. QuotaExceeded (large
   collections, full storage) just means no cache; every path degrades to the
   network fetch. */
var PL_CATALOG_TTL_MS = 15 * 60 * 1000;
function plCatalogCacheKey() { return 'plmc:catalog:' + plCatalogUrl(); }
function plCatalogReadCache() {
  try {
    var raw = sessionStorage.getItem(plCatalogCacheKey());
    if (!raw) return null;
    var wrapped = JSON.parse(raw);
    if (!wrapped || !wrapped.t || (Date.now() - wrapped.t) > PL_CATALOG_TTL_MS) return null;
    return wrapped.d || null;
  } catch (e) { return null; }
}
function plCatalogHasFreshCache() { return !!plCatalogReadCache(); }
function plCatalogWriteCache(text) {
  try {
    sessionStorage.setItem(plCatalogCacheKey(), JSON.stringify({ t: Date.now(), d: text }));
  } catch (e) { /* quota - skip */ }
}

/* Fetch + parse the catalog JSON. credentials:'include' MUST match the
   crossorigin="use-credentials" on the section's preload link; a mismatch makes
   the browser ignore the preloaded response and fetch again. */
function plFetchCatalog() {
  var cached = plCatalogReadCache();
  if (cached !== null) {
    try { return Promise.resolve(JSON.parse(cached)); } catch (e) { /* fall through */ }
  }
  // No custom headers: keep the request identical to the preload so the
  // browser can serve it from the preload cache.
  return fetch(plCatalogUrl(), { credentials: 'include' }).then(function (res) {
    if (!res.ok) throw new Error('catalog fetch failed: ' + res.status);
    return res.text();
  }).then(function (text) {
    // Shopify serves alternate templates as text/html; the body is pure JSON.
    var parsed = JSON.parse(text); // parse first - never cache a bad payload
    plCatalogWriteCache(text);
    return parsed;
  });
}

/* Returns a Promise that resolves once api_data/filter_values are built.
   Memoized: every caller shares one in-flight request. A legacy inline
   #mc-catalog-data blob is still honoured (parsed synchronously) so the
   section can be rolled back without touching this file. */
function plBuildCatalog() {
  if (window.plCatalogPromise) return window.plCatalogPromise;

  var inline = document.getElementById('mc-catalog-data');
  var source;
  if (inline) {
    source = new Promise(function (resolve, reject) {
      try { resolve(JSON.parse(inline.textContent)); } catch (e) { reject(e); }
    });
  } else {
    source = plFetchCatalog();
  }

  window.plCatalogPromise = source.then(function (catalog) {
    plBuildFromCatalog(catalog);
    window.plCatalogReady = true;
    return true;
  }).catch(function (e) {
    console.error('[main-collection] catalog unavailable', e);
    // Clear the memo so retryCatalog() can try again.
    window.plCatalogPromise = null;
    throw e;
  });

  return window.plCatalogPromise;
}

function plBuildFromCatalog(catalog) {
  // Idempotent: a retry after a partial failure must not double-push.
  api_data.variants.length = 0;
  Object.keys(filter_values).forEach(function (k) {
    if (k === 'availability') return;
    filter_values[k].length = 0;
  });

  var products = (catalog && catalog.products) || [];

  for (var pIdx = 0; pIdx < products.length; pIdx++) {
    var p = products[pIdx];
    var _product_index = pIdx + 1;

    var product = {
      id: p.id,
      handle: p.handle,
      title: p.title,
      tags: p.tags,
      available: p.available,
      featured_image: p.featured_image,
      featured_ar: p.featured_ar || 0, /* PL 2026-10-30 CLS: width/height ratio for the card <img> */
      type: p.type,
      created_at: p.created_at,
      variants: p.variants,
      tag_discount: (typeof p.tag_discount === 'number') ? p.tag_discount : 0
    };

    var pm = {
      texture: p.metafields.texture,
      skill_level: p.metafields.skill_level,
      hair_type: p.metafields.hair_type,
      sale_message: p.metafields.sale_message,
      judgeme: {
        // badge HTML is no longer serialised - stars render from the numeric
        // rating in main-collection.liquid
        average_rating: p.rating_value,
        review_count: p.rating_count
      }
    };

    safelyPushUnique('texture', pm.texture);
    safelyPushUnique('skill_level', pm.skill_level);
    safelyPushUnique('method', p.type);
    safelyPushUnique('hair_type', pm.hair_type);

    var p_tag_discount = product.tag_discount;

    // A length with no image of its own borrows one from another length of the same
    // shade, so its card shows the shade and not the product's main photo (Oct 2026).
    var shadeImage = {};
    for (var sIdx = 0; sIdx < p.variants.length; sIdx++) {
      var sv = p.variants[sIdx], sColor = sv[p.opt.color];
      if (sColor && sv.featured_image && !shadeImage[sColor]) shadeImage[sColor] = sv.featured_image;
    }

    for (var vIdx = 0; vIdx < p.variants.length; vIdx++) {
      var v = p.variants[vIdx];
      if (!v.featured_image && shadeImage[v[p.opt.color]]) v.featured_image = shadeImage[v[p.opt.color]];

      if (display_only_sale_variants && !v.last_chance) continue;

      var color = v[p.opt.color];
      var length = v[p.opt.length];
      var size = v[p.opt.size];
      // Canonical resolution (assets/pl-promo.js). Discounts are no longer pre-baked
      // here; variant_price / variant_compare_price ARE the display values from the
      // resolver, covering tag campaigns, both last-chance modes, and Pro pricing.
      var _vpr = window.plPromo ? window.plPromo.resolve(product, v)
        : { displayPrice: v.price, comparePrice: (v.compare_at_price || 0), badgeType: 'none', badgeLabel: '', badgePct: 0, lcActive: false };
      var variant_price = _vpr.displayPrice;
      var variant_compare_price = _vpr.comparePrice > _vpr.displayPrice ? _vpr.comparePrice : null;
      var lc_applied = _vpr.lcActive;

      if (!display_only_sale_variants) {
        // Check if variant matches filter keyword (if filter exists)
        // Uses exact matching for lengths, substring matching for colors
        if (filter_keyword.length && !variantMatchesFilterKeyword(v, p.opt.length, p.opt.color, filter_keyword)) {
          continue;
        }
      }

      safelyPushUnique('color', color);
      safelyPushUnique('length', length ? String(length).split('/')[0].trim() : length);
      safelyPushUnique('size', size);
      /* promo_tier reaches the browser from templates/collection.catalog.liquid.
         Guarded because most variants carry no tier and pushing undefined would
         make the facet appear on a grid with nothing discounted. */
      if (v.promo_tier) safelyPushUnique('discount', String(v.promo_tier));

      api_data.variants.push({
        variant: v,
        variant_label: v.variant_label,
        color: color,
        on_sale: variant_compare_price != null,
        promo: _vpr,
        length: length,
        size: size,
        product_metafields: pm,
        rating_value: p.rating_value,
        rating_count: p.rating_count,
        variant_price: variant_price,
        variant_compare_price: variant_compare_price,
        product: product,
        _product_index: _product_index,
        _variant_index: display_only_sale_variants ? (vIdx + 1) : vIdx
      });
    }
  }
}

/* --- variantsData() : Alpine factory (variant-display mode) --- */
function variantsData() {
			return {
				catalogLoading: true,
				catalogError: false,
				/* false | true | 'leaving'. Sync-checked against the session cache so a
				   cache-hit pageview never mounts the skeleton at all - not even for a
				   frame. 'leaving' keeps it mounted for the 180ms dissolve. */
				showSkeleton: !plCatalogHasFreshCache(),
				dismissSkeleton() {
					if (!this.showSkeleton) return;
					var self = this;
					self.showSkeleton = 'leaving';
					setTimeout(function () { self.showSkeleton = false; }, 200);
				},
				async retryCatalog() {
					this.catalogError = false;
					this.catalogLoading = true;
					this.showSkeleton = true;
					await this.init();
				},
				getUrlParams() {
					const params = new URLSearchParams(window.location.search);
					return params;
				},
				setUrlParams(params, replace = true) {
					const url = `${window.location.pathname}?${params.toString()}`;
					if (replace) history.replaceState(null, "", url);
					else history.pushState(null, "", url);
				},
				data: api_data,
				items_per_page: parseInt(mcCfg.itemsPerPage, 10) || 48,
				page: 0,
				filter_values: filter_values,
				loading: false,
				variants: [],
				color_filter_values: [],
				length_filter_values: [],
				filter_keyword: filter_keyword,
				settings: api_data.settings,
				section_blocks: section_blocks,
				available_variants_count: 0,
				unavailable_variants_count: 0,
				displayed_variants: [],
				observer: null,
				handleInch(value) {
					value = value || "";
					return value.replace('"', '').trim();
				},
				filtered_variants: [],
				filters: {
					availability: [],
					discount: [],
					length: [],
					color: [],
					size: [],
					texture: [],
					skill_level: [],
					hair_type: [],
					method: []
				},

				showAllColors: false,
				individualColors: [],

				get activeFilterCount() {
					const filtersCount = Object.values(this.filters).reduce((total, filterArray) => {
						return total + (Array.isArray(filterArray) ? filterArray.length : 0);
					}, 0);
					return filtersCount + this.individualColors.length;
				},

				bindPopState() {
					this._onPop = () => {
						this.applyFiltersFromUrl();
						this.handleFiltersFromPopstate();
					};
					window.addEventListener('popstate', this._onPop);
				},
				filtersToUrlParams() {
					const params = new URLSearchParams();
					if (this.sort_by) params.set("sort_by", this.sort_by);
					this.filters.availability.forEach(v => {
						const key = v === true || v === "1" || v === "In stock" ? "in-stock" : "out-of-stock";
						params.append("availability", key);
					});
					this.filters.color.forEach(v => params.append("custom_filter.color", v));
					this.individualColors.forEach(v => params.append("custom_color", v));
					this.filters.length.forEach(v => params.append("custom_filter.length", this.handleInch(v)));
					this.filters.size.forEach(v => params.append("custom_filter.size", v));
					this.filters.texture.forEach(v => params.append("custom_filter.texture", v));
					this.filters.skill_level.forEach(v => params.append("custom_filter.skill_level", v));
					this.filters.hair_type.forEach(v => params.append("custom_filter.hair_type", v));
					this.filters.method.forEach(v => params.append("custom_filter.product_type", v));
					(this.filters.discount || []).forEach(v => params.append("custom_filter.discount", v));

					return params;
				},
				hydrated: false,
				updateUrlFromFilters({ replace = false } = {}) {
					if(!this.hydrated) return;
					const params = this.filtersToUrlParams();
					this.setUrlParams(params, replace);
				},

				saleMessage(tag) {
					switch (tag) {
						case '10% Off':
							return mcCfg.promoLabels['10% Off'];
						case '15% Off':
							return mcCfg.promoLabels['15% Off'];
						case '20% Off':
							return mcCfg.promoLabels['20% Off'];
						case '25% Off':
							return mcCfg.promoLabels['25% Off'];
						case '30% Off':
							return mcCfg.promoLabels['30% Off'];
						case '35% Off':
							return mcCfg.promoLabels['35% Off'];
						case '50% Off':
							return mcCfg.promoLabels['50% Off'];
						case '60% Off':
							return mcCfg.promoLabels['60% Off'];
						case 'Sale Message':
							return mcCfg.promoLabels['Sale Message'];
						default:
							return '';
					}
				},
				// Price/badge resolution now lives in assets/pl-promo.js (window.plPromo).
				// sel_price, sel_compare_price and sel_promo arrive fully resolved; the old
				// proPriceWins/proPrice/campaignPercent helpers were removed with it.
				// Campaign slot for a percent, from window.themeVariables.settings.campaigns.
				// Always returns an object so the Alpine templates can read .style/.code
				// without null guards. Unmapped percents get pill_percent + the generic name.
				campaignSlot(percent) {
					const p = parseInt(percent, 10) || 0;
					const list = (this.settings && this.settings.campaigns) || [];
					for (let i = 0; i < list.length; i++) {
						const c = list[i];
						if (c && parseInt(c.percent, 10) === p) {
							return {
								style: c.style || 'pill_percent',
								code: c.code || '',
								percentBg: c.percentBg || '',
								nameBg: c.nameBg || '',
								nameText: c.nameText || ''
							};
						}
					}
					return { style: 'pill_percent', code: '', percentBg: '', nameBg: '', nameText: '' };
				},

				isProductExcludedFromFallback(productTags) {
					const excludedTags = (mcCfg.promoFallbackExcludedTags || []);
					if (!excludedTags.length) return false;
					
					const cleanedExcludedTags = excludedTags.map(tag => tag.toLowerCase().trim());
					const cleanedProductTags = (productTags || []).map(tag => tag.toLowerCase().trim());
					
					return cleanedExcludedTags.some(excludedTag => 
						cleanedProductTags.includes(excludedTag)
					);
				},
				getFallbackPriceHtml(price, isFromPrice = false) {
					const enableFallback = mcCfg.enablePromoFallback;
					const showCalcPrice = mcCfg.promoFallbackShowCalcPrice;
					const discountPercent = mcCfg.promoFallbackDiscountPercent;
					const discountMultiplier = (100 - discountPercent) / 100;
					
					if (!enableFallback || !showCalcPrice || this.settings.isProStylist) {
						return isFromPrice ? ('From ' + formatMoney(price)) : formatMoney(price);
					}
					
					const discountedPrice = Math.round(price * discountMultiplier);
					const prefix = isFromPrice ? 'From ' : '';
					return prefix + '<span class="sr-only">Sale price: </span><span class="price price--highlight">' + formatMoney(discountedPrice) + '</span> <span class="sr-only">Original price: </span><span class="price price--compare">' + formatMoney(price) + '</span>';
				},
				// Prefer the reactive selection (sel_*) written by selectLength(). The card's
				// representative variant is only a fallback: on multi-length products with
				// per-variant compare-at, 16" and 20" can sit at different discount depths,
				// and reading data.variant_* freezes the pill to whichever length rendered first.
				getSalePercent() {
					const compareAt = (this.sel_compare_price != null)
						? this.sel_compare_price
						: (this.data.variant_compare_price || this.data.variant.compare_at_price);
					const price = (this.sel_price != null)
						? this.sel_price
						: (this.data.variant_price || this.data.variant.price);
					if (compareAt == null || price == null) return 0;
					if (compareAt <= price) return 0;
					return Math.round((1 - price / compareAt) * 100);
				},
				setupObserver() {
					if (mcCfg.paginationStyle === 'load_more') return;
					const options = {
						root: null,
						rootMargin: '0px',
						threshold: 1.0,
					};

					this.observer = new IntersectionObserver((entries) => {
						entries.forEach(entry => {
							if (entry.isIntersecting) {
								this.loadMore();
							}
						});
					}, options);

					if (this.$refs.loadMore instanceof Element) {
						this.observer.observe(this.$refs.loadMore);
					}
					
				},

				// On desktop the promo blocks are single grid cells inline in the variant
				// flow (the full-row .promotion-block--expand rule only applies at <=740px),
				// so the LAST row fills only when (variants + interspersed promo cells) is a
				// whole multiple of the desktop column count. This counts the promo cells that
				// render among the first `n` variants, mirroring the grid's isPromoPosition.
				promoCellsWithin(n) {
					const { basePositions, repeatDistance, showOnce } = promoConfig;
					const nblocks = (this.section_blocks || []).length;
					let count = 0;
					for (let idx = 0; idx < n; idx++) {
						const pos1 = idx + 1;
						for (let i = 0; i < basePositions.length && i < nblocks; i++) {
							const pos = basePositions[i];
							if (showOnce) {
								if (pos1 === pos) count++;
								continue;
							}
							const offset = Math.floor((pos1 - pos) / repeatDistance);
							if (offset >= 0 && pos1 === pos + offset * repeatDistance) count++;
						}
					}
					return count;
				},
				/* PL 2026-10-30 perf: the promo blocks that render at grid position `index`.
				   Same rule as promoCellsWithin() and the old per-card x-if, but evaluated once
				   per card instead of creating one template + effect per block per card. */
				promoBlocksAt(index) {
					const blocks = this.section_blocks || [];
					if (!blocks.length) return [];
					const { basePositions, repeatDistance, showOnce } = promoConfig;
					const pos1 = index + 1;
					const out = [];
					for (let i = 0; i < blocks.length && i < basePositions.length; i++) {
						const pos = basePositions[i];
						if (showOnce) { if (pos1 === pos) out.push(blocks[i]); continue; }
						const offset = Math.floor((pos1 - pos) / repeatDistance);
						if (offset >= 0 && pos1 === pos + offset * repeatDistance) out.push(blocks[i]);
					}
					return out;
				},
				// Grow `target` until the visible grid ends on a complete row, so there's no
				// orphan row above "Show More". When everything is already shown, a partial
				// final row is unavoidable, so we return the full count untouched.
				rowSafeCount(target) {
					const total = this.filtered_variants.length;
					const cols = parseInt(mcCfg.desktopCols, 10) || 3;
					let n = Math.min(target, total);
					while (n < total && (n + this.promoCellsWithin(n)) % cols !== 0) n++;
					return n;
				},
				loadMore() { if (this._plGrowing) { this.loading = false; return; }
					const target = this.displayed_variants.length + (this.items_per_page || 60);
					const next = this.rowSafeCount(target);

					this.displayed_variants = this.filtered_variants.slice(0, next);
					if (this.displayed_variants.length >= this.filtered_variants.length) {
						this.observer?.disconnect();
					}
					this.loading = false;
				},
				sort_by: "best-selling",
				get showProductsMessage() {
					const shown = this.displayed_variants.length;
					const total = this.filtered_variants.length;
					// These are variant cards (one per shade in dedupe mode, per length when
					// exploded), not Shopify products - a single product shows as many cards -
					// so "results" is accurate in both modes.
					const noun = total === 1 ? 'result' : 'results';
					if (shown >= total) {
						return `Showing all ${total} ${noun}`;
					}
					return `Showing ${shown} of ${total} ${noun}`;
				},
				get sortByName() {
					return this.sort_by_options.find(option => option.value === this.sort_by)?.name || '';
				},
				sort_by_options: [
					{value: 'best-selling', name: 'Best selling'},
					{value: 'title-ascending', name: 'Alphabetically, A-Z'},
					{value: 'title-descending', name: 'Alphabetically, Z-A'},
					{value: 'price-ascending', name: 'Price, low to high'},
					{value: 'price-descending', name: 'Price, high to low'},
					{value: 'date-ascending', name: 'Date, old to new'},
					{value: 'date-descending', name: 'Date, new to old'},
				],
				sortVariants() {
					switch (this.sort_by) {
						case 'best-selling':
							this.filtered_variants.sort((a, b) => a._product_index - b._product_index);
							break;
						case 'title-ascending':
							this.filtered_variants.sort((a, b) => a.variant.title.localeCompare(b.variant.title));
							break;
						case 'title-descending':
							this.filtered_variants.sort((a, b) => b.variant.title.localeCompare(a.variant.title));
							break;
						case 'price-ascending':
							this.filtered_variants.sort((a, b) => (a.variant_price ?? a.variant.price) - (b.variant_price ?? b.variant.price));
							break;
						case 'price-descending':
							this.filtered_variants.sort((a, b) => (b.variant_price ?? b.variant.price) - (a.variant_price ?? a.variant.price));
							break;
						case 'date-ascending':
							this.filtered_variants.sort((a, b) => new Date(a.product.created_at) - new Date(b.product.created_at));
							break;
						case 'date-descending':
							this.filtered_variants.sort((a, b) => new Date(b.product.created_at) - new Date(a.product.created_at));
							break;
					}

					// Demote out-of-stock cards only when the collection allows it.
					// Default is true; set the custom.demote_out_of_stock collection
					// metafield to false to keep sold-out bestseller colors in their
					// natural sort position (strict check - value may arrive as a string).
					if (this.settings.demoteOutOfStock !== false && this.settings.demoteOutOfStock !== 'false') {
						this.filtered_variants.sort((a, b) => {
							return a.variant.available === b.variant.available ? 0 : a.variant.available ? -1 : 1;
						});
					}

					/* PL 2026-10-30 perf: render the first rows now and the rest in small chunks, so Alpine never builds every card in one long task. */ const plFull = this.rowSafeCount(this.items_per_page || 60); const plGen = (this._plRenderGen = (this._plRenderGen || 0) + 1); const plFirst = this.rowSafeCount(12); if (plFull > plFirst && !document.hidden) { this._plGrowing = true; this.displayed_variants = this.filtered_variants.slice(0, plFirst); const grow = () => { if (plGen !== this._plRenderGen) return; const cur = this.displayed_variants.length; const n = Math.max(cur, Math.min(plFull, this.rowSafeCount(cur + 12))); if (n > cur) this.displayed_variants = this.filtered_variants.slice(0, n); if (n < plFull) { setTimeout(grow, 0); } else { this._plGrowing = false; this.plTrackItemList(); } }; setTimeout(grow, 0); } else { this._plGrowing = false; this.displayed_variants = this.filtered_variants.slice(0, plFull); this.plTrackItemList(); }
				},
				/* GA4 view_item_list emission. sortVariants() is the single funnel
				   every render path passes through (initial load, filters, sort,
				   popstate), so one debounced hook here covers them all. Debounce
				   absorbs the multiple sort calls during boot and rapid filter taps;
				   the signature check skips pushes when the visible list is
				   unchanged (e.g. a sort that produced the same head slice). Items
				   are capped at 20 per GA4 guidance; prices are converted from
				   cents. Show-more pagination intentionally does not re-fire - it
				   extends the same list rather than presenting a new one. */
				plTrackItemList() {
					clearTimeout(this._plItemListTimer);
					this._plItemListTimer = setTimeout(() => {
						try {
							var visible = this.displayed_variants.slice(0, 20);
							var signature = visible.map(function (v) { return v.variant.id; }).join(',');
							if (!visible.length || signature === this._plItemListSig) return;
							this._plItemListSig = signature;
							var listName = (this.settings && this.settings.collection_title) || document.title;
							window.dataLayer = window.dataLayer || [];
							window.dataLayer.push({ ecommerce: null });
							window.dataLayer.push({
								event: 'view_item_list',
								ecommerce: {
									item_list_name: listName,
									items: visible.map(function (entry, idx) {
										return {
											item_id: String(entry.variant.id),
											item_name: entry.product.title,
											item_variant: entry.variant.title || '',
											price: (typeof entry.variant_price === 'number' ? entry.variant_price / 100 : undefined),
											index: idx,
											item_list_name: listName
										};
									})
								}
							});
						} catch (e) {}
					}, 600);
				},
				handleize(input) {
					return input
						.toLowerCase()
						.replace(/[^a-z0-9\s-]/g, '')
						.replace(/\s+/g, '-')
						.replace(/-+/g, '-');
				},

				recomputeFilterValues() {
					// Disjunctive faceting: for each facet, rebuild its available options
					// from the variant set filtered by ALL OTHER active facets (not itself),
					// so multi-select within a facet still works while other facets narrow.
					// The snippet's x-show conditions read filter_values, so options whose
					// value is no longer present get hidden automatically.
					const facetKeys = ['length', 'color', 'size', 'texture', 'skill_level', 'method', 'hair_type'];

					// Base pool respects the same source/stock rules as handleFilters().
					const hasAnyFilter = Object.values(this.filters).some(filter => filter.length > 0) || this.individualColors.length > 0;
					let basePool = this.needsLengthExpansion() ? this.all_variants : this.deduped_variants;
					if (this.settings.hideOutOfStock) {
						basePool = basePool.filter(item => item.variant.available);
					}

					const next = {
						availability: ['In stock', 'Out of stock'],
						length: [],
						color: [],
						size: [],
						texture: [],
						skill_level: [],
						method: [],
						hair_type: []
					};

					const pushUniqueLocal = (arr, value) => {
						if (value && !arr.includes(value)) arr.push(value);
					};

					for (const facet of facetKeys) {
						// Items matching every OTHER active facet, ignoring this facet's own selection.
						const otherKeys = Object.keys(this.filters).filter(k => k !== facet);
						const subset = basePool.filter(item => otherKeys.every(k => this.hasItem(k, item)));

						for (const item of subset) {
							switch (facet) {
								case 'color':
									pushUniqueLocal(next.color, item.color);
									break;
								case 'length':
									pushUniqueLocal(next.length, item.length?.split('/')[0]?.trim());
									break;
								case 'size':
									pushUniqueLocal(next.size, item.size);
									break;
								case 'texture':
									pushUniqueLocal(next.texture, item.product_metafields.texture);
									break;
								case 'skill_level':
									pushUniqueLocal(next.skill_level, item.product_metafields.skill_level);
									break;
								case 'method':
									pushUniqueLocal(next.method, item.product.type);
									break;
								case 'hair_type':
									pushUniqueLocal(next.hair_type, item.product_metafields.hair_type);
									break;
							}
						}
					}

					// Preserve any keyword-narrowed color/length values already in play.
					this.filter_values.length = next.length;
					this.filter_values.color = next.color;
					this.filter_values.size = next.size;
					this.filter_values.texture = next.texture;
					this.filter_values.skill_level = next.skill_level;
					this.filter_values.method = next.method;
					this.filter_values.hair_type = next.hair_type;
				},
				hasItem(key, item) {
					switch (key) {
						case "availability": {
							if (this.filters[key].length === 0) return true;
							// Shopify's availability filter submits "1" / "0"; the URL round-trip
							// uses "In stock" / "Out of stock". Accept both.
							const av = this.filters[key].map(v => String(v));
							const wantInStock = av.includes("In stock") || av.includes("1");
							const wantOutOfStock = av.includes("Out of stock") || av.includes("0");
							return (wantInStock && item.variant.available) || (wantOutOfStock && !item.variant.available);
						}
						case "discount":
							/* Exact tier match. An unflagged variant has no promo_tier, so it
							   drops out as soon as any pill is active - which is the intent:
							   picking "50% off" should show only 50% off items. */
							return this.filters[key].length === 0
								|| this.filters[key].includes(String(item.variant.promo_tier || ''));
						case "length":
							return this.filters[key].length === 0 || this.filters[key].some(v => this.handleInch(v) === this.handleInch(item.length));
						case "color":
							if (this.individualColors.length > 0) {
								return this.individualColors.includes(item.color);
							}
							return this.filters[key].length === 0 || this.filters[key].includes(plGetColorGroup(item.color));
						case "size":
							return this.filters[key].length === 0 || this.filters[key].includes(item.size);
						case "skill_level":
							return this.filters[key].length === 0 || this.filters[key].includes(item.product_metafields.skill_level);
						case "method":
							return this.filters[key].length === 0 || (this.filters[key].includes(item.product.type) || this.filters[key].some(word => item.product.type?.toLowerCase().includes(word?.toLowerCase())));
						case "texture":
							return this.filters[key].length === 0 || this.filters[key].includes(item.product_metafields.texture);
						case "hair_type":
							return this.filters[key].length === 0 || this.filters[key].includes(item.product_metafields.hair_type);
						default:
							return this.filters[key].length === 0;
					}
				},
				formatMoney(cents, format = "") {
					if (typeof cents === "string") {
						cents = cents.replace(".", "");
					}
					const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
						formatString = format || window.themeVariables.settings.moneyFormat;

					function defaultTo(value2, defaultValue) {
						return value2 == null || value2 !== value2 ? defaultValue : value2;
					}

					function formatWithDelimiters(number, precision, thousands, decimal) {
						precision = defaultTo(precision, 2);
						thousands = defaultTo(thousands, ",");
						decimal = defaultTo(decimal, ".");
						if (isNaN(number) || number == null) {
							return 0;
						}
						number = (number / 100).toFixed(precision);
						let parts = number.split("."),
							dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
							centsAmount = parts[1] ? decimal + parts[1] : "";
						return dollarsAmount + centsAmount;
					}

					let value = "";
					switch (formatString.match(placeholderRegex)[1]) {
						case "amount":
							value = formatWithDelimiters(cents, 2).replace(".00", "");
							break;
						case "amount_no_decimals":
							value = formatWithDelimiters(cents, 0);
							break;
						case "amount_with_space_separator":
							value = formatWithDelimiters(cents, 2, " ", ".");
							break;
						case "amount_with_comma_separator":
							value = formatWithDelimiters(cents, 2, ".", ",");
							break;
						case "amount_with_apostrophe_separator":
							value = formatWithDelimiters(cents, 2, "'", ".");
							break;
						case "amount_no_decimals_with_comma_separator":
							value = formatWithDelimiters(cents, 0, ",", ".");
							break;
						case "amount_no_decimals_with_space_separator":
							value = formatWithDelimiters(cents, 0, " ");
							break;
						case "amount_no_decimals_with_apostrophe_separator":
							value = formatWithDelimiters(cents, 0, "'");
							break;
					}
					if (formatString.indexOf("with_comma_separator") !== -1) {
						return formatString.replace(placeholderRegex, value);
					} else {
						return formatString.replace(placeholderRegex, value);
					}
				},
				removeAllFiters() {
					this.filters = {
						availability: [],
						discount: [],
						length: [],
						color: [],
						size: [],
						texture: [],
						skill_level: [],
						hair_type: [],
						method: []
					};
					this.individualColors = [];
					this.handleFilters();
				},
				removeFilter(key, value) {
					let filter = this.filters[key].filter(item => item !== value);
					this.filters[key] = filter;
					this.handleFilters();
				},
				removeIndividualColor(value) {
					this.individualColors = this.individualColors.filter(item => item !== value);
					this.handleFilters();
				},
				handleFilters() {
					// A shopper can tap a filter while the catalog is still downloading on a
					// slow connection. Remember it and apply it once the catalog lands
					// (init() skips the URL read when this is set).
					if (this.catalogLoading || !this.all_variants) { this._pendingFilters = true; return; } /* PL 2026-10-30 INP: let the tapped filter paint first, then filter in the next task. Rapid taps coalesce into one run. */ if (!this._plFilterNow) { if (!this._plFilterQueued) { this._plFilterQueued = true; const go = () => { this._plFilterQueued = false; this._plFilterNow = true; this.handleFilters(); }; if (document.hidden) go(); else requestAnimationFrame(() => setTimeout(go, 0)); } return; } this._plFilterNow = false;
					const hasAnyFilter = Object.values(this.filters).some(filter => filter.length > 0) || this.individualColors.length > 0;
					const source = this.needsLengthExpansion() ? this.all_variants : this.deduped_variants;
					this.filtered_variants = source.filter(item => Object.keys(this.filters).every(key => this.hasItem(key, item)));
					if (this.settings.hideOutOfStock) {
						this.filtered_variants = this.filtered_variants.filter(item => item.variant.available);
					}
					
					this.available_variants_count = this.filtered_variants.filter(item => item.variant.available)?.length;
					this.unavailable_variants_count = this.filtered_variants.filter(item => !item.variant.available)?.length;

					this.recomputeFilterValues();
					this.sortVariants();
					// replaceState: Back leaves the collection instead of stepping through
					// every checkbox the shopper toggled.
					this.updateUrlFromFilters({ replace: true });
					this.observer?.disconnect();
					this.setupObserver();

				},
				handleFiltersFromPopstate() {
					const hasAnyFilter = Object.values(this.filters).some(filter => filter.length > 0) || this.individualColors.length > 0;
					const source = this.needsLengthExpansion() ? this.all_variants : this.deduped_variants;
					this.filtered_variants = source.filter(item => Object.keys(this.filters).every(key => this.hasItem(key, item)));
					if (this.settings.hideOutOfStock) {
						this.filtered_variants = this.filtered_variants.filter(i => i.variant.available);
					}
					this.available_variants_count = this.filtered_variants.filter(i => i.variant.available)?.length;
					this.unavailable_variants_count = this.filtered_variants.filter(i => !i.variant.available)?.length;
					this.recomputeFilterValues();
					this.sortVariants();
					this.observer?.disconnect?.();
					this.setupObserver();
				},
				hasLengthOption() {
					return this.variants.some(it => it.length && String(it.length).trim().length > 0);
				},

				getMinPriceForCurrentGroup(productId) {
					const group = this.variants.filter(it => it.product?.id === productId);
					if (!group.length) return null;

					let min = Infinity;
					for (const it of group) {
						const price = it.variant_price ?? it.variant?.price ?? null;
						if (typeof price === 'number' && price < min) min = price;
					}
					return Number.isFinite(min) ? min : null;
				},

				hasPriceVarianceForCurrentGroup(productId) {
					const group = this.variants.filter(it => it.product?.id === productId);
					const prices = new Set(
						group
							.map(it => (it.variant_price ?? it.variant?.price))
							.filter(v => typeof v === 'number')
					);
					return prices.size > 1;
				},

				buildDedupeKey(item) {
					const p = item.product || {};
					const v = item.variant || {};
					const color  = item.color || v.option1 || "";
					const method = p.type || "";
					const texture = item.product_metafields?.texture || "";
					const skill   = item.product_metafields?.skill_level || "";
					return [
						p.id ?? "",
						color,
						method,
						texture,
						skill
					].join("|");
				},

				// Cards collapse variants that differ only by length. That model must stay
				// constant while filtering, otherwise the grid and the counts change unit
				// the moment any filter is applied. The only exception is a length filter,
				// which requires the expanded pool to match against.
				needsLengthExpansion() {
					return !!(this.filters && this.filters.length && this.filters.length.length > 0);
				},
				dedupeByIgnoringLength(variants) {
					const groups = new Map();

					for (const item of variants) {
						const key = this.buildDedupeKey(item);
						if (!groups.has(key)) groups.set(key, []);
						groups.get(key).push(item);
					}

					const pickRepresentative = (arr) => {
						const available = arr.filter(i => i.variant?.available);
						const pool = available.length ? available : arr;
						return pool.reduce((best, cur) => {
							const bestPrice = (best.variant_price ?? best.variant?.price ?? Number.POSITIVE_INFINITY);
							const curPrice  = (cur.variant_price  ?? cur.variant?.price  ?? Number.POSITIVE_INFINITY);
							return curPrice < bestPrice ? cur : best;
						}, pool[0]);
					};

					const out = [];
					for (const arr of groups.values()) {
						out.push(pickRepresentative(arr));
					}
					return out;
				},


				get canLoadMore() {
					return this.displayed_variants.length < this.filtered_variants.length;
				},
				async init() {
					// Catalog arrives from ?view=catalog (see plBuildCatalog). Everything
					// below reads api_data / filter_values, so nothing runs until it lands.
					this.catalogLoading = true;
					this.catalogError = false;
					try {
						await plBuildCatalog();
					} catch (e) {
						this.catalogLoading = false;
						this.showSkeleton = false;
						this.catalogError = true;
						return;
					}
					this.catalogLoading = false;
					this.dismissSkeleton();
					this.variants = this.data.variants;
					this.all_variants = this.data.variants; 
					var lengthVariants = (mcCfg.lengthVariants === true || mcCfg.lengthVariants === 'true');
					if(lengthVariants) {
						this.deduped_variants = this.data.variants; 
					} else {
						this.deduped_variants = this.dedupeByIgnoringLength(this.all_variants.slice());
					}
					this.color_filter_values = this.filter_values.color.filter(item => this.filter_keyword.some(word => item.split('(')[0].includes(word)));
					this.length_filter_values = this.filter_values.length.filter(item => this.filter_keyword.some(word => this.handleInch(item) == this.handleInch(word)));

					if (this.length_filter_values.length > 0) {
						this.filter_values.length = this.length_filter_values;
					}
					if (this.color_filter_values.length > 0) {
						this.filter_values.color = this.color_filter_values;
					}

					if (this.filter_keyword.length) {
						this.variants = this.variants.filter(item => this.filter_keyword.some(word => item.variant.title.includes(word)));
					}

					if (this.length_filter_values.length) {
						this.variants = this.variants.filter(item => this.length_filter_values.some(word => this.handleInch(item.length) == this.handleInch(word)));
					}
					if (!this._pendingFilters) this.applyFiltersFromUrl();
					const hasAnyFilter = Object.values(this.filters).some(filter => filter.length > 0);
					const source = this.needsLengthExpansion() ? this.all_variants : this.deduped_variants;
					this.filtered_variants = source.filter(item => Object.keys(this.filters).every(key => this.hasItem(key, item)));
					if (this.settings.hideOutOfStock) {
						this.filtered_variants = this.filtered_variants.filter(item => item.variant.available);
					}
					this.available_variants_count = this.filtered_variants.filter(item => item.variant.available)?.length;
					this.unavailable_variants_count = this.filtered_variants.filter(item => !item.variant.available)?.length;

					this.recomputeFilterValues();
					this.sortVariants();
					this.setupObserver();
					this.hydrated = true;
					if (this._pendingFilters) { this._pendingFilters = false; this.updateUrlFromFilters({ replace: true }); }
					this.bindPopState();
					var $alpineInstance = this;
					
					// Improved scroll handler - loads all products before scrolling to target
					// This ensures the target section is at its final position
					var scrollTargetElements = document.querySelectorAll('.scroll-to-section, .anchor-bottom');
					if (scrollTargetElements.length) {
						scrollTargetElements.forEach(function(element) {
							element.addEventListener('click', function(e) {
								e.preventDefault();
								
								// Get href from clicked element or parent anchor
								var target = e.target;
								var href = target.getAttribute('href');
								if (!href && target.closest('a')) {
									href = target.closest('a').getAttribute('href');
								}
								
								if (!href) return;
								
								var targetSection = document.querySelector(href);
								if (!targetSection) {
									console.warn('Scroll target not found:', href);
									return;
								}
								
								// Disconnect observer to prevent interference during load
								if ($alpineInstance.observer) {
									$alpineInstance.observer.disconnect();
								}
								
								// Show loading state on clicked link
								var clickedLink = target.closest('a') || target.closest('button') || target;
								var originalOpacity = clickedLink.style.opacity;
								clickedLink.style.opacity = '0.6';
								clickedLink.style.pointerEvents = 'none';
								
								/**
								 * Recursively loads all remaining products before scrolling
								 * This ensures the #learn-more section is at its final position
								 */
								function loadAllProductsThenScroll() {
									var totalVariants = $alpineInstance.filtered_variants.length;
									var currentlyDisplayed = $alpineInstance.displayed_variants.length;
									
									// If all products already loaded, scroll immediately
									if (currentlyDisplayed >= totalVariants) {
										performScroll();
										return;
									}
									
									// Load next batch
									var start = $alpineInstance.displayed_variants.length;
									var end = Math.min(start + $alpineInstance.items_per_page, totalVariants);
									
									$alpineInstance.displayed_variants.push(
										...$alpineInstance.filtered_variants.slice(start, end)
									);
									
									// Check if done loading
									if ($alpineInstance.displayed_variants.length >= totalVariants) {
										// All loaded - wait for DOM render then scroll
										requestAnimationFrame(function() {
											setTimeout(performScroll, 150);
										});
									} else {
										// More to load - continue
										requestAnimationFrame(function() {
											setTimeout(loadAllProductsThenScroll, 30);
										});
									}
								}
								
								/**
								 * Performs the scroll after all products are loaded
								 */
								function performScroll() {
									// Calculate position with header offset
									var headerOffset = 100;
									var elementPosition = targetSection.getBoundingClientRect().top;
									var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
									
									window.scrollTo({
										top: offsetPosition,
										behavior: 'smooth'
									});
									
									// Restore link state
									clickedLink.style.opacity = originalOpacity || '';
									clickedLink.style.pointerEvents = '';
									
									// Focus target section for accessibility (screen readers)
									targetSection.setAttribute('tabindex', '-1');
									targetSection.focus({ preventScroll: true });
									
									// Re-setup infinite scroll observer after scroll completes
									setTimeout(function() {
										$alpineInstance.setupObserver();
									}, 2000);
								}
								
								// Start loading all products
								loadAllProductsThenScroll();
							});
						});
					}

				},
				decodeHTML(encodedString) {
					var doc = new DOMParser().parseFromString(encodedString, 'text/html');
					return doc.body.textContent || doc.body.innerText;
				},
				applyFiltersFromUrl() {
					try {
						const params = this.getUrlParams();
						const sort = params.get("sort_by");
						this.sort_by = sort || "best-selling";
						const avail = params.getAll("availability");
						this.filters.availability = avail.length ? avail.map(v => (v === "in-stock" ? "In stock" : "Out of stock")) : [];
						const colors = params.getAll("custom_filter.color");
						this.filters.color = colors.length ? colors : [];
						const individualColors = params.getAll("custom_color");
						this.individualColors = individualColors.length ? individualColors : [];
						// Open the individual swatches drawer if the URL has individualColors
						if (this.individualColors.length > 0) {
							this.showAllColors = true;
						}
						const lengths = params.getAll("custom_filter.length");
						this.filters.length = lengths.length ? lengths : [];
						const sizes = params.getAll("custom_filter.size");
						this.filters.size = sizes.length ? sizes : [];
						const textures = params.getAll("custom_filter.texture");
						this.filters.texture = textures.length ? textures : [];
						const skills = params.getAll("custom_filter.skill_level");
						this.filters.skill_level = skills.length ? skills : [];
						const hairTypes = params.getAll("custom_filter.hair_type");
						this.filters.hair_type = hairTypes.length ? hairTypes : [];
						const methods = params.getAll("custom_filter.product_type");
						this.filters.method = methods.length ? methods : [];
						this.filters.discount = params.getAll("custom_filter.discount");
					} catch (error) {
						console.warn('Error parsing URL filters:', error);
						this.sort_by = "best-selling";
						this.individualColors = [];
						this.filters = {
							availability: [],
							discount: [],
							length: [],
							color: [],
							size: [],
							texture: [],
							skill_level: [],
							hair_type: [],
							method: []
						};
					}
				},

			};
		}

/* --- ratingBarFromBadge() : Alpine factory (review badge) --- */
function ratingBarFromBadge(data) {
		return {
		r: 0,
		c: 0,
		init() {
			const r1 = Number(String(data?.rating_value ?? data?.product_metafields?.judgeme?.average_rating ?? '').replace(',', '.'));
			const c1 = parseInt(String(data?.rating_count ?? data?.product_metafields?.judgeme?.review_count ?? '').replace(/[^\d]/g,''), 10);
			if (!Number.isNaN(r1) && r1 > 0) this.r = r1;
			if (!Number.isNaN(c1) && c1 > 0) this.c = c1;

		}
		};
	}

/* --- product-mode pagination + grid layout (DOMContentLoaded) --- */
document.addEventListener("DOMContentLoaded", function () {
		// Collapse setting is mobile-intent: on desktop, default the filter groups to open
		// on load, but leave the toggle fully functional (no forced CSS) so users can collapse.
		if (window.matchMedia("(min-width: 1000px)").matches) {
			document.querySelectorAll(".product-facet__filters .product-facet__filter-item").forEach(function (item) {
				var toggle = item.querySelector(".collapsible-toggle[is='toggle-button']");
				var content = item.querySelector("collapsible-content.collapsible");
				if (toggle && content && !content.hasAttribute("open")) {
					content.setAttribute("open", "");
					toggle.setAttribute("aria-expanded", "true");
				}
			});
		}

		const productListContainer = document.getElementById("product-list-container");
		let isFetching = false;

		const lazyLoadImages = () => {
			const lazyImages = document.querySelectorAll("img.lazy");
			lazyImages.forEach((img) => {
				if (img.getBoundingClientRect().top < window.innerHeight && img.dataset.src) {
					img.src = img.dataset.src;
					img.removeAttribute("data-src");
					img.classList.remove("lazy");
				}
			});
		};

		const applyGridLayout = () => {
			// Variant mode sizes its grid in CSS (#product-list-container rules in the
			// section, which honour the mobile/tablet/desktop column settings).
			if (mcCfg.displayVariants) return;
			const isMobile = window.innerWidth <= 768;
			// Read --section-products-per-row from the grid container, which inherits
			// the value set on the section wrapper. Reading from document.documentElement
			// returned empty (the variable is never defined on :root), which forced the
			// `|| 3` fallback and pinned every collection to 3 columns via inline style.
			const gridColumns = isMobile
				? 2
				: getComputedStyle(productListContainer || document.documentElement)
					.getPropertyValue("--section-products-per-row")
					.trim();

			if (productListContainer) {
				productListContainer.style.gridTemplateColumns = `repeat(${gridColumns || 3}, minmax(0, 1fr))`;
			}
		};

		if (!mcCfg.displayVariants) {

		if (mcCfg.paginationStyle === 'load_more') {
		/* Load More button handler (Mode B) */
		const loadMoreBtn = document.getElementById("load-more-btn");
		const loadMoreWrap = document.getElementById("collection-load-more");

		if (loadMoreBtn && productListContainer) {
			loadMoreBtn.addEventListener("click", function () {
				if (isFetching) return;
				const nextUrl = loadMoreBtn.getAttribute("data-next-url");
				if (!nextUrl) return;

				isFetching = true;
				loadMoreBtn.disabled = true;
				loadMoreBtn.textContent = "Loading...";

				fetch(nextUrl)
					.then((response) => response.text())
					.then((html) => {
						const parser = new DOMParser();
						const doc = parser.parseFromString(html, "text/html");

						const newProducts = doc.querySelectorAll(".product-list__inner .product-item");
						if (newProducts.length > 0) {
							const fragment = document.createDocumentFragment();
							newProducts.forEach((product) => fragment.appendChild(product));
							productListContainer.appendChild(fragment);

							const newMsg = doc.querySelector('.show-products-message');
							const oldMsg = document.querySelector('.show-products-message');
							if (newMsg && oldMsg) oldMsg.innerHTML = newMsg.innerHTML;

							lazyLoadImages();
							fadeInlazyLoadedImages();
							applyGridLayout();
						}

						const newLoadMoreBtn = doc.getElementById("load-more-btn");
						if (newLoadMoreBtn) {
							loadMoreBtn.setAttribute("data-next-url", newLoadMoreBtn.getAttribute("data-next-url"));
							loadMoreBtn.disabled = false;
							loadMoreBtn.textContent = "Show more products";
						} else {
							loadMoreWrap.style.display = "none";
						}

						const newPagination = doc.querySelector('.collection-pagination');
						const oldPagination = document.querySelector('.collection-pagination');
						if (newPagination && oldPagination) {
							oldPagination.innerHTML = newPagination.innerHTML;
						}

						isFetching = false;
					})
					.catch((error) => {
						console.error("Error loading products:", error);
						loadMoreBtn.disabled = false;
						loadMoreBtn.textContent = "Show more products";
						isFetching = false;
					});
			});
		}
		} else {
		/* Infinite scroll handler (Mode B) */
		const productLimit = mcCfg.productPerPage;
		const loader = document.getElementById("infinite-scroll-loader");
		let currentPage = 1;

		const loadMoreProducts = () => {
			if (isFetching) return;
			isFetching = true;
			currentPage++;
			// PL 2026-10-08 audit: keep filter.* / sort_by / q etc. from the current URL;
			// building from pathname alone loaded unfiltered, unsorted next pages.
			const nextUrlObj = new URL(window.location.href);
			nextUrlObj.searchParams.set('page', currentPage);
			nextUrlObj.searchParams.set('limit', productLimit);
			nextUrlObj.hash = '';
			const nextPageUrl = nextUrlObj.pathname + nextUrlObj.search;

			loader.style.display = "block";

			fetch(nextPageUrl)
				.then((response) => response.text())
				.then((html) => {
					const parser = new DOMParser();
					const doc = parser.parseFromString(html, "text/html");

					const newProducts = doc.querySelectorAll(".product-list__inner .product-item");

					if (newProducts.length > 0) {
						const fragment = document.createDocumentFragment();
						newProducts.forEach((product) => fragment.appendChild(product));
						productListContainer.appendChild(fragment);

						document.querySelector('.show-products-message').innerHTML = doc.querySelector('.show-products-message').innerHTML;
						lazyLoadImages();
						fadeInlazyLoadedImages();
						applyGridLayout();
					} else {
						loader.style.display = "none";
						observer.disconnect();
					}

					isFetching = false;
				})
				.catch((error) => {
					console.error("Error loading products:", error);
					loader.style.display = "none";
					isFetching = false;
				});
		};

		const observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					loadMoreProducts();
				}
			});
		}, {
			root: null,
			rootMargin: "0px",
			threshold: 1.0
		});

		if (loader) {
			observer.observe(loader);
		}
		}

		}
		window.addEventListener("resize", applyGridLayout);

		lazyLoadImages();
		applyGridLayout();
	});

/* --- fadeInlazyLoadedImages() : image fade-in --- */
function fadeInlazyLoadedImages() {
		const images = document.querySelectorAll("img.product-item__primary-image");
		images.forEach((img) => {
			// Check if image is already loaded (from cache or fast load)
			if (img.complete && img.naturalHeight !== 0) {
				img.classList.add("lazy-loaded");
			} else {
				img.addEventListener("load", () => {
					img.classList.add("lazy-loaded");
				});
			}
		});
	}

	document.addEventListener('DOMContentLoaded', function () {
		const swatchContainers = document.querySelectorAll('.product-item-meta__swatch-container');

		swatchContainers.forEach((container) => {
			const scrollListWrapper = container.querySelector('.product-item-meta__swatch-list-wrapper');
			const scrollList = container.querySelector('.color-swatch-list');
			const leftArrow = container.querySelector('.scroll-arrow--left');
			const rightArrow = container.querySelector('.scroll-arrow--right');

			const updateArrowsState = () => {
				const scrollLeft = scrollList.scrollLeft;
				const maxScrollLeft = scrollList.scrollWidth - scrollList.clientWidth;

				leftArrow.classList.toggle('disabled', scrollLeft === 0);
				rightArrow.classList.toggle('disabled', scrollLeft >= maxScrollLeft);
			};

			const checkArrowsVisibility = () => {
				const isScrollable = scrollList.scrollWidth > scrollListWrapper.clientWidth;
				leftArrow.style.display = isScrollable ? 'block' : 'none';
				rightArrow.style.display = isScrollable ? 'block' : 'none';
			};

			checkArrowsVisibility();
			updateArrowsState();

			leftArrow.addEventListener('click', () => {
				scrollList.scrollBy({left: -100, behavior: 'smooth'});
			});

			rightArrow.addEventListener('click', () => {
				scrollList.scrollBy({left: 100, behavior: 'smooth'});
			});


			scrollList.addEventListener('scroll', updateArrowsState);
		});
	});

	document.addEventListener('DOMContentLoaded', function () {
		const swatchAreas = document.querySelectorAll('.swatch-area');

		swatchAreas.forEach((swatchArea) => {
			const swatchList = swatchArea.querySelector('.color-swatch-list');
			const swatches = swatchList ? swatchList.querySelectorAll('.color-swatch') : [];

			if (swatches.length <= 1) {
				swatchArea.style.display = 'none';
			}
		});

		fadeInlazyLoadedImages();

		// MutationObserver to handle dynamically added images (Alpine.js renders + AJAX filter replacements)
		const facetMain = document.getElementById('facet-main');
		if (facetMain && !mcCfg.displayVariants) {
			const imageObserver = new MutationObserver((mutations) => {
				let hasNewImages = false;
				mutations.forEach((mutation) => {
					mutation.addedNodes.forEach((node) => {
						if (node.nodeType === 1) {
							const images = node.matches && node.matches('img.product-item__primary-image') 
								? [node] 
								: node.querySelectorAll ? node.querySelectorAll('img.product-item__primary-image') : [];
							
							if (images.length) hasNewImages = true;
							
							images.forEach((img) => {
								if (img.complete && img.naturalHeight !== 0) {
									img.classList.add('lazy-loaded');
								} else {
									img.addEventListener('load', () => {
										img.classList.add('lazy-loaded');
									}, { once: true });
								}
							});
						}
					});
				});
				// Re-run for any images that might have been missed
				if (hasNewImages) fadeInlazyLoadedImages();
			});

			facetMain.addEventListener('transitionend', fadeInlazyLoadedImages);

			imageObserver.observe(facetMain, {
				childList: true,
				subtree: true
			});
		}

	});